import type { ReactNode } from "react";
import type { VendorDetail } from "@/lib/api/acquisitions";

type VendorContactSectionProps = {
  vendor: VendorDetail;
};

export function VendorContactSection({ vendor }: VendorContactSectionProps) {
  const websiteHref = vendor.website
    ? vendor.website.startsWith("http")
      ? vendor.website
      : `https://${vendor.website}`
    : null;

  return (
    <section className="rounded-lg border border-slate-200 bg-white px-4 py-4 sm:px-5">
      <h2 className="text-sm font-semibold text-slate-900">Contact</h2>
      <dl className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <Field label="Email">
          {vendor.email ? (
            <a href={`mailto:${vendor.email}`} className="text-primary hover:underline">
              {vendor.email}
            </a>
          ) : (
            "—"
          )}
        </Field>
        <Field label="Phone">
          {vendor.phone ? (
            <a href={`tel:${vendor.phone}`} className="text-primary hover:underline">
              {vendor.phone}
            </a>
          ) : (
            "—"
          )}
        </Field>
        <Field label="Website">
          {websiteHref ? (
            <a
              href={websiteHref}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline break-all"
            >
              {vendor.website}
            </a>
          ) : (
            "—"
          )}
        </Field>
        <Field label="Address">{vendor.address || "—"}</Field>
      </dl>
    </section>
  );
}

function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div>
      <dt className="text-xs text-slate-500">{label}</dt>
      <dd className="mt-0.5 text-sm text-slate-900">{children}</dd>
    </div>
  );
}
